'use client'
import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import { ISingleOrder } from '@/_service/types/orders'

const StepStatus = ({ order }: { order?: ISingleOrder }) => {
  const isDesktop = useIsDesktop()

  return isDesktop ? <Desktop order={order} /> : <Mobile order={order} />
}

export default StepStatus
